import { render } from "./groups-list.vue?vue&type=template&id=71bbe5b2&scoped=true"
import script from "./groups-list.vue?vue&type=script&lang=js"
export * from "./groups-list.vue?vue&type=script&lang=js"

import "./groups-list.vue?vue&type=style&index=0&id=71bbe5b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bbe5b2"]])

export default __exports__